import { GiftOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Table } from "antd";
import "antd/dist/antd.css";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { User } from "../../../../../Entryfile/imagepath";
import Api from "../../../../../initialpage/hooks/Api";
import { itemRender, onShowSizeChange } from "../../../../paginationfunction";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import { imageApi } from "../../../../../initialpage/hooks/HrApi";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const UserProfiles = () => {
  // get User Data
  const { data: dataSource, error, mutate } = useSWR(`hr/employee`, fetcher);

  const columns = [
    {
      title: "EMPLOYEE ID",
      className: "dark_bg ",
      dataIndex: "EMPLOYEE_ID",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type employee id here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.EMPLOYEE_ID == value;
      },
    },
    {
      title: "PHOTO",
      className: "dark_bg ",
      //   dataIndex: "PHOTO_PATH",
      render: (text, record) => (
        <div className="text-center">
          <td>
            {record.PHOTO_PATH ? (
              <img
                style={{ height: "70px", width: "70px" }}
                src={`${imageApi}${record.PHOTO_PATH}`}
                alt=""
              />
            ) : (
              <img
                src={User}
                alt=""
                style={{ height: "70px", width: "70px" }}
              />
            )}
          </td>
        </div>
      ),
    },

    {
      title: "NAME",
      className: "dark_bg ",
      dataIndex: "NAME_ENGLISH",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.NAME_ENGLISH.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "DESIGNATION",
      className: "dark_bg ",
      dataIndex: "DESIGNATION",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type Designation name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.DESIGNATION.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "DEPARTMENT",
      className: "dark_bg ",
      dataIndex: "DEPARTEMENT",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type Department name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        if (record.DEPARTEMENT) {
          return record.DEPARTEMENT.toLowerCase().includes(value.toLowerCase());
        }
      },
    },
    {
      title: "CONTACT",
      className: "dark_bg ",
      dataIndex: "MOBILE_PHONE",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type number here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        if (record.MOBILE_PHONE) {
          return record.MOBILE_PHONE.toLowerCase().includes(
            value.toLowerCase()
          );
        }
      },
    },
    {
      title: "Action",
      className: "dark_bg ",
      render: (text, record) => (
        <div className="text-center">
          <Link to={`/systemaccess/userprofile/category/${record.EMPLOYEE_ID}`}>
            <Button
              className="btn-color_store"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Access Product"
              shape="circle"
              icon={<GiftOutlined />}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      <Helmet>
        <title>UserProfile - BBA Store</title>
        <meta name="description" content="UserProfile - BBA Store" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        {!dataSource ? (
          <NotFoundPage></NotFoundPage>
        ) : (
          <div className="content container-fluid main-container">
            <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
              <h3 className="text-start text-dark">
                User Profiles (Total Records: {dataSource.length})
              </h3>
              <div></div>
            </div>

            <div className="row ">
              <div className="col-md-12 px-5">
                <div className="table-responsive">
                  <Table
                    className="table-striped"
                    pagination={{
                      total: dataSource === undefined ? 0 : dataSource.length,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      showSizeChanger: true,
                      onShowSizeChange: onShowSizeChange,
                      itemRender: itemRender,
                    }}
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    // bordered
                    dataSource={dataSource === undefined ? [] : dataSource}
                    rowKey={(record) => record.UNIT_ID}
                    onChange={console.log("change")}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfiles;
